(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/Collection', 'services/visitExtService'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var visitExtService = require('./../urls').visitExtService;
    module.exports = factory(require('backbone-torso/modules/Collection'), visitExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(TorsoCollection, visitExtService) {
  'use strict';

  /**
   * Receives visits from the VisitExtService which serves the VisitDTO resource
   * @class VisitCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    url: visitExtService,
    fetchHttpAction: 'POST'
  }))();
}));
